export const urlToFile = async (url: string) => {
  const file = await fetch(url)
    .then((r) => r.blob())
    .then((blobFile) => new File([blobFile], 'profilePhoto', { type: 'image/png' }));

  return file;
};
